<template>
    <el-dialog :width="tableWidth" :title="title" v-if="visible" :visible.sync="visible" :before-close="handleClose" class="order-filter-log">
        <div class="filter-list">
            <div class="filter-list-title">
                <span class="title">订单号</span>
                <ul class="table-lists">
                    <li class="filter-list-details" v-for="(item, index) in filterList" :key="index"
                    @click="fliterListClick(item, index)" @dblclick="dblclick(item)"
                    :class="{'active' : clickIndex === index ? true : false}">{{item}}</li>
                </ul>
            </div>
            <el-table class="filter-table" :data="data" border :height="400" highlight-current-row
                :row-class-name="tableRowClassName" :row-key="getRowKeys" ref="moduleTable"
                @cell-dblclick="cellDBlclick" @selection-change="handleSelectionChange"
                @row-click="rowClick">
                <el-table-column prop="operateName" label="操作类型" show-overflow-tooltip
                    width="180" align="center">
                    <template v-slot="scope">
                        <el-button type="text"
                            size="mini" v-if="canJump(scope.row)"
                            @click.stop="logJumpBtn(scope.row)">
                            {{scope.row.operateName}}
                        </el-button>
                        <template v-else>{{scope.row.operateName}}</template>
                    </template>
                </el-table-column>
                <el-table-column prop="operateFlag" label="操作结果" show-overflow-tooltip
                    width="120" align="center">
                    <template v-slot="scope">
                        <span v-if="scope.row.operateFlag === 'N'" class="error-text">失败</span>
                        <span v-else>成功</span>
                    </template>
                </el-table-column>
                <el-table-column prop="updateUserCode" label="操作人" show-overflow-tooltip
                    width="120" align="center"></el-table-column>
                <el-table-column prop="updateTime" label="操作时间" show-overflow-tooltip
                    width="180" align="center"></el-table-column>
                <el-table-column prop="operateContent" label="备注" show-overflow-tooltip
                    align="center">
                    <template v-slot="scope">
                        <span :class="{'error-text': scope.row.operateFlag === 'N'}">{{ scope.row.operateContent }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
import { sendPickUpCode } from '../../../../api/orderCenter';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        tableData: {
            type: Array
        },
        items: {
            type: Array
        },
        title: {
            type: String
        },
        tableWidth: {
            type: [Number, String],
            default() {
                return '60%';
            }
        },
        logJumpParams: {
            type: Object,
            default() {
                return {};
            }
        },
        logOrderNo: {
            type: String,
            default: ''
        },
        currentData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            data: this.tableData,
            headerFilterNames: {},
            tableHeaders: [
                { prop: 'orderNo', label: '订单号' },
                { prop: 'operateName', label: '操作类型' },
                { prop: 'operateFlag', label: '操作结果' },
                { prop: 'updateUserCode', label: '操作人' },
                { prop: 'updateTime', label: '操作时间' },
                { prop: 'operateContent', label: '备注' }
            ],
            orderNoFilters: [],
            filterList: ['全部'],
            selectedRowsData: [],
            clickIndex: 0
        };
    },
    methods: {
        rowClick(rows) {
            rows.checked = !rows.checked;
            this.$refs.moduleTable.toggleRowSelection(rows, rows.checked);
        },
        handleSelectionChange(selection) {
            this.selectedRowsData = selection;
        },
        tableRowClassName({ row }) {
            if (this.selectedRowsData && this.selectedRowsData.map(item => item.id).includes(row.id)) {
                // return 'highlight-row';
            }
        },
        getRowKeys(row) {
            if (!row.expandsRandomKey) row.expandsRandomKey = row.id + Math.random().toString().substr(-10);
            return row.expandsRandomKey;
        },
        handleClose() {
            // this.visible = false;
            this.clickIndex = 0;
            this.delBodyClass();
            this.$emit('handleClose', '');
        },
        resetDateFilter() {
            this.$refs.filterTable.clearFilter('date');
        },
        clearFilter() {
            this.$refs.filterTable.clearFilter();
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        renderHeader(h, data) {
            const header = this.tableHeaders[data.$index - 1] || {};
            return (
                <span class="log-header">
                    <el-input value={this.headerFilterNames[header.prop]}
                        on-input={ (val) => { this.fetch(header.prop, val); } }
                        on-keydown={ (val) => { this.fetch(header.prop, val); } }
                        on-change={(val) => this.fetch(header.prop, val)}
                        clearable></el-input>
                    <br/>
                    <span>{data.column.label}</span>
                </span>
            );
        },
        fetch(name, val) {
            let tableDataTemp = this.tableData;
            this.$set(this.headerFilterNames, name, val);
            const tempFilter = {};
            Object.keys(this.headerFilterNames).forEach(key => {
                if (this.headerFilterNames[key]) {
                    tempFilter[key] = this.headerFilterNames[key];
                }
            });
            for (const key in tempFilter) {
                if (tempFilter.hasOwnProperty(key)) {
                    tableDataTemp = tableDataTemp.filter(item => {
                        if (item[key].indexOf(tempFilter[key].trim()) >= 0) {
                            return item;
                        }
                    });
                }
            }
            this.data = tableDataTemp;
        },
        logJumpBtn(row) {
            const { operateType, operateFlag, operateContent } = row;
            const { businessMode, orderType, siteCode, siteName, whCode, whName, deliveryType, customerAgingCode, inOutType } = this.currentData;
            const { customerOrderNo, ...params } = { ...this.logJumpParams };
            const routePath = this.$route.path;
            if (['APART', 'APART_HAND'].includes(operateType)) {
                this.$router.push({
                    name: 'stockCenter',
                    params: { ...params, routePath }
                });
            } else if (operateType === 'OUTINCONFIRM') {
                this.$router.push({
                    name: 'accessStock',
                    params: { customerOrderNo, routePath }
                });
            } else if (operateType === 'AGING_PRODUCT') {
                const comParams = {
                    isRefresh: true,
                    businessMode: businessMode,
                    orderType: orderType,
                    siteCode: siteCode,
                    siteName: siteName,
                    whCode: whCode,
                    whName: whName,
                    deliveryType: deliveryType
                };
                let params = {};
                if (operateFlag === 'Y') {
                    params = {
                        isRefresh: true,
                        customerAgingCode: customerAgingCode || operateContent.split('：')[2]
                    };
                } else {
                    if (orderType === 'YS') {
                        params = {
                            ...comParams,
                            receiveProvinceCode: this.currentData.receiverProvinceCode || '',
                            receiveCityCode: this.currentData.receiverCityCode || '',
                            sendProvinceCode: this.currentData.senderProvinceCode || '',
                            sendCityCode: this.currentData.senderCityCode || ''
                        };
                    } else if (
                        (businessMode === 'B2B' && inOutType === 'IN') ||
                        (businessMode === 'B2C' && ['RI', 'DPRI'].includes(orderType)) ||
                        (businessMode === 'B2C' && inOutType === 'IN' && orderType === 'DP')
                    ) {
                        params = {
                            ...comParams,
                            sendProvinceCode: this.currentData.senderProvinceCode || '',
                            sendCityCode: this.currentData.senderCityCode || ''
                        };
                    } else {
                        params = {
                            ...comParams,
                            receiveProvinceCode: this.currentData.receiverProvinceCode || '',
                            receiveCityCode: this.currentData.receiverCityCode || ''
                        };
                    }
                }
                this.$router.push({
                    name: 'customerPrescription',
                    params: { ...params }
                });
            } else if (operateType === 'SEND_PICK_UP_CODE') {
                this.sendPickUpCode(row);
                return;
            }
            this.$emit('handleClose', '');
        },
        sendPickUpCode(row) {
            if (row.operateFlag === 'Y') {
                return;
            }
            sendPickUpCode(row.parentOrderNo).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('发送成功');
                }
            });
        },
        unique(arr) {
            const res = new Map();
            return arr.filter((a) => !res.has(a) && res.set(a, 1));
        },
        copyText(cellEl, copyText) {
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            cellEl.appendChild(input);
            input.select();
            document.execCommand('copy');
            cellEl.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        cellDBlclick(row, column, cell, event) {
            if (column.property === 'operateContent') {
                this.copyText(cell.children[0], cell.children[0].innerText);
            }
        },
        fliterListClick(item, index) {
            this.clickIndex = index;
            if (item === '全部') {
                this.data = this.tableData;
            } else if (item === this.logOrderNo) {
                this.data = this.tableData.filter(data => !data.orderNo || data.orderNo === item);
            } else {
                this.data = this.tableData.filter(data => data.orderNo === item);
            }
        },
        dblclick(val) {
            this.copyText(document.querySelector('.order-filter-log .filter-list-details'), val);
        },
        delBodyClass() {
            const body = document.body;
            const cls = body.className.replace('log-tooltip', '');
            body.setAttribute('class', cls);
        },
        showDialog() {
            const body = document.body;
            body.setAttribute('class', `${body.className} log-tooltip`);
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.showDialog();
            }
        },
        tableData(newVal) {
            this.orderNoFilters = [];
            this.filterList = ['全部'];
            newVal.map(item => {
                this.tableHeaders.forEach(header => {
                    if (item[header.prop] === undefined) {
                        item[header.prop] = '';
                    }
                });
            });
            this.data = newVal;
            const orderNos = this.data.map(item => item.orderNo);
            orderNos.unshift(this.logOrderNo);
            const newArr = this.unique(orderNos);
            newArr.map(item => {
                if (item) {
                    this.orderNoFilters.push(item);
                }
            });
            this.filterList = ['全部'].concat(this.orderNoFilters);
        }
    },
    computed: {
        canJump() {
            return function (row) {
                return ['APART', 'OUTINCONFIRM', 'APART_HAND', 'AGING_PRODUCT', 'SEND_PICK_UP_CODE'].includes(row.operateType);
            };
        }
    }
};
</script>

<style lang="less">
.order-filter-log {
    .error-text {
        color: #f56c6c;
    }
    .el-dialog__body {
        padding: 0 0 22px 0 ;
    }
    .log-header {
        .el-input__suffix {
            right: 10px;
        }
    }
    .filter-list {
        display: flex;
    }
    .filter-list-title {
        // height:100%;
        max-height: 400px;
        line-height: 33px;
        font-size:14px;
        text-align: center;
        color:#333;
        .title {
            line-height: 35px;
            width: 100%;
            display: inline-block;
            background-color: #F6F6F7;
        }
        .table-lists {
            width:198px;
            overflow: auto;
            height: 365px;
            background: #fff;
            color: #333;
            .filter-list-details{
                cursor: pointer;
                border-left: 1px solid #EBEEF5;
                border-bottom: 1px solid #EBEEF5;
            }
            .active {
                background: #e1e9ef;
            }
        }
        .filter-table {
            width: 100%;
        }
    }
}
.log-tooltip .el-tooltip__popper {
    max-width: 70%;
    margin-right: 10%;
}
</style>
